<template>
  <div
    v-for="(item, index) in checkoutProductList"
    :key="item.id || index"
    class="mb-5 d-flex align-start"
  >
    <!-- Product image skeleton -->
    <div style="width: 77px; flex-shrink: 0" class="">
      <v-skeleton-loader
        class="chekout-page-image-skeleton"
        color="transparent"
        type="image"
        width="76"
        height="56"
      ></v-skeleton-loader>
    </div>

    <!-- Product details skelton -->
    <div class="flex-grow-1 d-flex flex-column justify-center">
      <!-- Product name skeleton -->
      <div class="mb-1">
        <v-skeleton-loader
          class="checkout-page-carts-text-field"
          color="transparent"
          type="text"
          width="70%"
        ></v-skeleton-loader>
      </div>

      <!-- Quantity skeleto -->
      <div class="mb-1">
        <v-skeleton-loader
          class="checkout-page-carts-text-field"
          color="transparent"
          type="text"
          width="30%"
        ></v-skeleton-loader>
      </div>

      <!-- Price skeleton -->
      <div class="mb-1">
        <v-skeleton-loader
          class="checkout-page-carts-text-field"
          color="transparent"
          type="text"
          width="25%"
        ></v-skeleton-loader>
      </div>
    </div>

    <!-- Total price skeleton -->
    <div>
      <v-skeleton-loader
        class="checkout-page-carts-text-field"
        color="transparent"
        type="text"
        width="90px"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutProductListSkeleton",
  props: {
    checkoutProductList: {
      type: Number,
      default: 2,
    },
  },
};
</script>